export const FONT = "'DM Sans', system-ui, -apple-system, sans-serif";
export const FONT_MONO = "'DM Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
export const GRAD = "linear-gradient(135deg, #4477B7, #68CA91)";

export interface ThemeTokens {
  bg: string; bgAlt: string; surface: string; surfaceAlt: string; surfaceDepressed: string;
  border: string; border2: string;
  text: string; text2: string; text3: string;
  accent: string; accentBg: string; accentText: string; accentBorder: string; accentButtonText: string;
  blue: string; blueBg: string; blueText: string;
  amber: string; amberBg: string; amberBgSubtle: string; amberText: string;
  purple: string; purpleBg: string; purpleText: string;
  red: string; redBg: string; redText: string; redBorder: string;
  sb: string; sbText: string; sbActive: string; sbHover: string;
  sbAccentBg: string; sbAccent: string; sbBorder: string;
  /** Categorical chart series colors (SC-2872 boards). Fixed assignment order
   *  chart1→chart4, never cycled; a 5th series folds into "Other". Each theme's
   *  set is validated with the dataviz six-checks against its chart surface
   *  (dark: `surface` #122A3A; light: #FFF) — re-run the validator if you touch
   *  these. */
  chart1: string; chart2: string; chart3: string; chart4: string;
}

export const lightTheme: ThemeTokens = {
  bg: "#F5F7F6", bgAlt: "#EAEFEC", surface: "#FFF", surfaceAlt: "#F0F4F2", surfaceDepressed: "#EAEFEC",
  border: "#D8DDD9", border2: "#C4CAC6",
  text: "#0C2638", text2: "#3A5060", text3: "#7A8D96",
  accent: "#68CA91", accentBg: "#E8F7EF", accentText: "#1B6B40", accentBorder: "#A3DFB8", accentButtonText: "#06222F",
  blue: "#4477B7", blueBg: "#E8F0F8", blueText: "#2B5A8A",
  amber: "#F59E0B", amberBg: "#FEF3C7", amberBgSubtle: "rgba(245,158,11,.08)", amberText: "#92400E",
  purple: "#818CF8", purpleBg: "#EEEDFE", purpleText: "#4338CA",
  red: "#EF4444", redBg: "#FEE2E2", redText: "#991B1B", redBorder: "rgba(239,68,68,.5)",
  sb: "#0C2638", sbText: "#8FAAB8", sbActive: "#FFF", sbHover: "#122F44",
  sbAccentBg: "rgba(104,202,145,.12)", sbAccent: "#68CA91", sbBorder: "#1A3A50",
  chart1: "#3D6EA8", chart2: "#2E7D53", chart3: "#5B67D8", chart4: "#008770",
};

export const darkTheme: ThemeTokens = {
  bg: "#06101A", bgAlt: "#0E2030", surface: "#122A3A", surfaceAlt: "#163044", surfaceDepressed: "#0F2434",
  border: "#1E3E52", border2: "#2A5068",
  text: "#E2ECF0", text2: "#A0B8C6", text3: "#6A8899",
  accent: "#68CA91", accentBg: "rgba(104,202,145,.12)", accentText: "#68CA91", accentBorder: "#2D7A50", accentButtonText: "#06222F",
  blue: "#5B8FCC", blueBg: "rgba(68,119,183,.15)", blueText: "#7AA8D9",
  amber: "#F59E0B", amberBg: "rgba(245,158,11,.15)", amberBgSubtle: "rgba(245,158,11,.07)", amberText: "#FBBF24",
  purple: "#818CF8", purpleBg: "rgba(129,140,248,.15)", purpleText: "#A5AEFF",
  red: "#EF4444", redBg: "rgba(239,68,68,.15)", redText: "#F87171", redBorder: "rgba(239,68,68,.5)",
  sb: "#0A141F", sbText: "#6A8899", sbActive: "#E2ECF0", sbHover: "#16273B",
  sbAccentBg: "rgba(104,202,145,.1)", sbAccent: "#68CA91", sbBorder: "#152535",
  chart1: "#5B8FCC", chart2: "#46A671", chart3: "#7D88EE", chart4: "#1CA391",
};
